import React from 'react'
import Modal from '../../components/Modal/Modal'
import Button from '../../components/Buttons/Button'
import styled from 'styled-components'
import ErrorIcon from "../../components/Icons/components/ErrorIcon";
import { Link } from "react-router-dom";

const PreventGoingBackModal = ({ show, closeModal }) => {

    return (
        <>
            <Modal show={show} closeModal={closeModal}>
                <ModalContent>
                    <IconContainer>
                        <ErrorIcon style={{width: '100px', height: '100px', margin: 'auto'}}/>
                    </IconContainer>
                    <TitleModal>Nie można wrócić do poprzedniej strony</TitleModal>
                    <Description>Twoje dane zostały pobrane z aplikacji mObywatel. Jezeli chcesz je zmienić rozpocznij składanie nowego wniosku.</Description>
                    <Button buttonType='primary' onClick={closeModal}>Zamknij</Button>
                    <Link to={'/basket'}>
                        <Button buttonType='outline' onClick={closeModal}>Nowy wniosek</Button>
                    </Link>
                </ModalContent>
            </Modal>
        </>
    )
}

export default PreventGoingBackModal

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px;
`

const TitleModal = styled.div`
    font-size: 20px;
    color: black;
    font-weight: bold;
    text-align: center;
`

const Description = styled.div`
    font-size: 16px;
    color: black;
    text-align: center;
    line-height: 25px;
`

const IconContainer = styled.div`
    font-size: 70px;
    text-align: center;
    svg {
        display: block;
        margin: auto;
    }
`;